<template>
  <div>
    {{ title }}
    <select v-model="selected">
      <option>All</option>
      <option>Delivery</option>
      <option>Return</option>
      <option>Crossdock Delivery</option>
      <option>Crossdock Pickup</option>
      <option>Common Carrier - GSO</option>
      <option>Common Carrier - FedEx</option>
    </select>
  </div>
</template>
<script>
export default {
  props: ['title', 'query'],
  data() {
    return {
      selected: 'All'
    };
  },
  watch: {
    selected(kw) {
      this.search();
    }
  },
  methods: {
    search() {
      const { query } = this;
      // `$props.query` would be initialized to `{ limit: 10, offset: 0, sort: '', order: '' }` by default
      // custom query conditions must be set to observable by using `Vue.set / $vm.$set`
      this.$set(query, 'type', this.selected.split(' ').join('_'));
      query.offset = 0; // reset pagination
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/OrderTable/components/thTypeFilter.vue